/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Search from "@mui/icons-material/Search";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
//import MDButton from "components/MDButton";
import { Button, Grid } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in2-basic.webp";
import logoImage from "assets/images/moona-logo.png";
import banyanImage from "assets/images/logos/Banyan.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { ColorRing } from "react-loader-spinner";
import Swal from "sweetalert2";
import { fetchAllFamilyMembers, fetchFamilyTreeGraph } from "../../../services/familyTreeService";

function SignUp() {
  const [signup, setSignup] = useState({
    user_name: "",
    first_name: "",
    last_name: "",
    email_c: "",
    phone_mobile: "",
    user_hash: "",
    cnfrm_c: "",
    gender: "", // new gender field
  });
  const [existingFamilyMember, setExistingFamilyMember] = useState(null); // null default
  const [familyGroupId, setFamilyGroupId] = useState("");
  const [familyGraphMembers, setFamilyGraphMembers] = useState([]);
  const [selectedFamilyMember, setSelectedFamilyMember] = useState("");
  const [pendingSelectedMember, setPendingSelectedMember] = useState(null);
  const [selectionConfirmOpen, setSelectionConfirmOpen] = useState(false);
  const [selectionConfirmMessage, setSelectionConfirmMessage] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [UserData, setUserData] = useState([]);
  const [userId, setUserId] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [matchedMember, setMatchedMember] = useState(null);
  const [isIdentityDialogOpen, setIsIdentityDialogOpen] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isExistingMember, setIsExistingMember] = useState(false);
  const [error, setError] = useState({
    emptyFeilds: "",
    valiatation: "",
    matchError: "",
    userNameError: "",
    emailError: "",
    phoneError: "",
    userNameMatchErr: "",
    emailDuplicateErr: "",
    phoneNumberDuplicateErr: "",
    existingFamilyMemberErr: "",
    genderErr: "",
    familyGroupIdErr: "",
    selectNameErr: "",
  });
  const [isValid, setIsValid] = useState(true);
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  const usernameRegex = /^[a-zA-Z0-9]{6,15}$/;
  // password valitation //

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referralId = queryParams.get("referral_id");
  const [referral, setReferral] = useState([]);
  const [referrerId, setReferrerId] = useState(null);

  const referData =
    referral.length > 0
      ? {
          firstName: referral[0].firstname_c?.value || "",
          lastName: referral[0].lastname_c?.value || "",
          referrerName: referral[0].referralname_c?.value || "",
          email: referral[0].email_c?.value || "",
          phoneNumber: referral[0].phone_number_c?.value || "",
          isRelation: referral[0].is_relation_c?.value || "",
          relationship: referral[0].relationship_c?.value || "",
          isRelated: referral[0].is_relation_c?.value === "1",
        }
      : {};

  useEffect(() => {
    if (referral.length > 0) {
      const ref = referral[0];

      setSignup((prev) => ({
        ...prev,
        first_name: ref.firstname_c?.value || "",
        last_name: ref.lastname_c?.value || "",
        email_c: ref.email_c?.value || "",
        phone_mobile: ref.phone_number_c?.value || "",
        referrerName: ref.referralname_c?.value || "",
      }));
    }
  }, [referral]);

  useEffect(() => {
    const fetctReferrerData = async () => {
      const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/customapi/Get.php";
      const payload = { referral_id: referralId };
      console.log(payload, "ref payload");

      try {
        const response = await axios.get(apiUrl, { params: payload });
        console.log("ref API Response:", response);

        const entryList = response.data.entry_list || [];
        console.log("entry list", entryList);

        const products = entryList.map((entry) => entry.name_value_list);
        const sortedData = products
          .filter((product) => product.date_modified)
          .sort((a, b) => new Date(b.date_modified?.value) - new Date(a.date_modified?.value));

        const referreruserId = sortedData[0].user_id_c?.value || "";
        console.log("referrer panavan id", referreruserId);
        setReferrerId(referreruserId);
        setReferral(sortedData);
      } catch (error) {
        if (error.response) {
          console.error("API error:", error.response.data);
        } else if (error.request) {
          console.error("No response received:", error.request);
        } else {
          console.error("Request setup error:", error.message);
        }
      }
    };

    if (referralId) {
      fetctReferrerData();
    }
  }, [referralId]);

  const handleUserGet = async () => {
    const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/customapi/Create.php";
    try {
      const response = await axios.get(apiUrl);

      if (response.status === 200) {
        console.log("User data fetched successfully");
        const entryList = response.data.entry_list;

        // Extracting name_value_list from each entry in entry_list and storing them in the products array
        const products = entryList.map((entry) => entry.name_value_list);
        setUserData(products);
      } else {
        console.error("Login failed:", response.data);
      }
    } catch (error) {
      if (error.response) {
        console.error("An error occurred during login:", error.response.data);
        console.error("Status code:", error.response.status);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };

  useEffect(() => {
    handleUserGet();
    fetchFamilyMembersData();
  }, []);

  const fetchFamilyMembersData = async () => {
    try {
      const members = await fetchAllFamilyMembers();
      console.log("Fetched family members:", members);
      setFamilyMembers(members);
    } catch (error) {
      console.error("Error fetching family members:", error);
    }
  };

  const sanitizeUsername = (name) => {
    if (!name) return "";
    let s = String(name).replace(/[^A-Za-z0-9]/g, "");
    s = s.toLowerCase();
    if (s.length < 6) {
      s = s + "123456".slice(0, 6 - s.length);
    }
    return s.slice(0, 15);
  };

  const handleFetchFamilyGraph = async () => {
    console.log('handleFetchFamilyGraph invoked. familyGroupId:', familyGroupId);
    if (!familyGroupId) {
      setError((prev) => ({ ...prev, familyGroupIdErr: 'Please enter Family Group ID' }));
      return;
    }

    try {
      const graphData = await fetchFamilyTreeGraph(familyGroupId);
      let members = [];
      if (Array.isArray(graphData)) {
        members = graphData;
      } else if (Array.isArray(graphData?.entries)) {
        members = graphData.entries;
      } else if (Array.isArray(graphData?.data)) {
        members = graphData.data;
      } else if (Array.isArray(graphData?.members)) {
        members = graphData.members;
      }
      // Normalize members -> build id map for lookups
      const idFor = (obj) => (obj?.id || obj?.user_id || obj?.userId || obj?.users_id_c || "").toString();
      const nameFor = (obj) => (obj?.name || obj?.full_name || `${obj?.first_name || ""} ${obj?.last_name || ""}`).trim();
      const membersMap = new Map(members.map((mm) => [idFor(mm), mm]));

      const names = members.map((m) => {
        const id = idFor(m);
        const displayName = nameFor(m) || id || "Unknown";

        // Helper: find member by id
        const findById = (idVal) => membersMap.get((idVal || "").toString());

        // Parents (support multiple naming formats)
        const rawParentId = m.parentid_c || m.parentid || m.parentId || "";
        const parentIds = rawParentId ? String(rawParentId).split(",").map(p => p.trim()).filter(Boolean) : [];
        const parents = parentIds.map(pid => findById(pid)).filter(Boolean);
        // Spouse and children precomputed for later use (declare here to avoid block scope issues)
        const spouseId = m.spouseid_c || m.spouseid || m.spouseId || "";
        const spouseObj = findById(spouseId);
        const children = (members || []).filter(c => {
          const pids = (c.parentid_c || c.parentid || c.parentId || "") + "";
          return pids.split(",").map(x => x.trim()).filter(Boolean).includes(id);
        });

        let label = displayName;

        if (parents.length > 0) {
          const father = parents.find(p => (p?.gender_c || p?.gender || "").toLowerCase().includes("male"));
          const mother = parents.find(p => (p?.gender_c || p?.gender || "").toLowerCase().includes("female"));
          const fatherName = nameFor(father) || "";
          const motherName = nameFor(mother) || "";
          const relation = ((m?.gender_c || m?.gender || "").toLowerCase().includes("male")) ? "S/o" : "D/o";
          const parentsText = [fatherName ? `${fatherName} (father)` : null, motherName ? `${motherName} (mother)` : null].filter(Boolean).join(" & ");
          if (parentsText) label = `${displayName} ${relation} ${parentsText}`;
        } else {
          // Spouse
          if (spouseObj) {
            const spouseName = nameFor(spouseObj) || "";
            const relation = ((m?.gender_c || m?.gender || "").toLowerCase().includes("male")) ? "H/o" : "W/o";
            const spouseGender = (spouseObj?.gender_c || spouseObj?.gender || "").toLowerCase();
            const spouseLabel = spouseGender.includes("male") ? "husband" : spouseGender.includes("female") ? "wife" : "";
            label = `${displayName} ${relation} ${spouseName}${spouseLabel ? ` (${spouseLabel})` : ""}`;
          } else if (children.length > 0) {
            // Children
            const childName = nameFor(children[0]) || "";
            const relation = ((m?.gender_c || m?.gender || "").toLowerCase().includes("male")) ? "F/o" : "M/o";
            label = `${displayName} ${relation} ${childName}`;
          }
        }

        // Determine relationship type for this member (parent, spouse, child, or self/none)
        let relationshipType = "";
        if (parents.length > 0) relationshipType = "parent";
        else if (spouseObj) relationshipType = "spouse";
        else if ((children || []).length > 0) relationshipType = "child";
        else if ((m?.id || "") === id) relationshipType = "self";

        return { id: id, name: label, original: m, relationshipType };
      });
      console.log('Fetched graph data, names:', names);
      setFamilyGraphMembers(names);
      setError((prev) => ({ ...prev, existingFamilyMemberErr: '', familyGroupIdErr: '', selectNameErr: '' }));
      // Preserve the entered Family Group ID across the app (for Family Tree page), but only after successful fetch
      try {
        localStorage.setItem('familyGroupId', String(familyGroupId));
      } catch (e) {
        console.warn('Failed to set familyGroupId in localStorage:', e);
      }
    } catch (err) {
      console.error('Error fetching family graph:', err);
      setError((prev) => ({ ...prev, familyGroupIdErr: 'Failed to fetch family graph' }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let isFormValid = true; // Assume form is valid initially

    setSignup((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Username validation
    if (name === "user_name") {
      if (!usernameRegex.test(value)) {
        setError((prevError) => ({
          ...prevError,
          userNameError:
            "*Username must be 6-15 characters long and contain only letters and numbers.*",
        }));
        isFormValid = false; // Mark form as invalid if username doesn't match the regex
      } else {
        setError((prevError) => ({
          ...prevError,
          userNameError: "", // Clear the error if username is valid
        }));
      }
    }
    // debugger

    // Password validation
    if (name === "user_hash") {
      if (!passwordRegex.test(value)) {
        setError((prevError) => ({
          ...prevError,
          valiatation:
            "*Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character.*",
        }));
        isFormValid = false; // Mark form as invalid if password doesn't match the regex
      } else {
        setError((prevError) => ({
          ...prevError,
          valiatation: "", // Clear the error if password is valid
        }));
      }
    }

    // Confirm password validation
    if (name === "cnfrm_c") {
      if (value !== signup.user_hash) {
        setError((prevError) => ({
          ...prevError,
          matchError: "Passwords do not match",
        }));
        isFormValid = false; // Mark form as invalid if passwords don't match
      } else {
        setError((prevError) => ({
          ...prevError,
          matchError: "", // Clear error if passwords match
        }));
      }
    }

    const MobileRegex = /^(?:\+91|91)?[6-9][0-9]{9}$/;
    if (name === "phone_mobile") {
      if (!MobileRegex.test(value)) {
        setError((prevError) => ({
          ...prevError,
          phoneError: "Enter valid Phone Number",
        }));
        isFormValid = false; // Mark form as invalid if passwords don't match
      } else {
        setError((prevError) => ({
          ...prevError,
          phoneError: "", // Clear error if passwords match
        }));
      }
    }

    // Existing Family Member field validation handled here
    if (name === "existingFamilyMember") {
      if (value === "" || value === null) {
        setError((prevError) => ({
          ...prevError,
          existingFamilyMemberErr: "Please select Existing Family Member option",
        }));
        isFormValid = false;
      } else {
        setError((prevError) => ({
          ...prevError,
          existingFamilyMemberErr: "",
        }));
        setExistingFamilyMember(value);
      }
    }

    if (name === "gender") {
      if (!value) {
        setError((prevError) => ({
          ...prevError,
          genderErr: "Please select gender",
        }));
        isFormValid = false;
      } else {
        setError((prevError) => ({
          ...prevError,
          genderErr: "",
        }));
      }
    }

    // Only set `isValid` if all validations are passed
    if (
      !error.userNameError &&
      !error.valiatation &&
      !error.matchError &&
      !error.phoneError &&
      !error.existingFamilyMemberErr &&
      !error.genderErr &&
      isFormValid
    ) {
      setIsValid(true); // If there are no errors and form is valid, allow submission
    } else {
      setIsValid(false); // Otherwise, prevent submission
    }

    // Only set `isValid` if all validations are passed
    if (
      !error.userNameError &&
      !error.valiatation &&
      !error.matchError &&
      !error.phoneError &&
      isFormValid
    ) {
      setIsValid(true); // If there are no errors and form is valid, allow submission
    } else {
      setIsValid(false); // Otherwise, prevent submission
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    // Initialize form validation flag
    let formValid = true;

    // Validation check for all empty fields
    if (
      signup.user_name === "" ||
      signup.first_name === "" ||
      signup.last_name === "" ||
      signup.email_c === "" ||
      signup.phone_mobile === "" ||
      signup.user_hash === "" ||
      signup.cnfrm_c === "" ||
      signup.gender === "" ||
      existingFamilyMember === null
    ) {
      // At least one field is empty, show specific error
      setError((prevError) => ({
        ...prevError,
        emptyFeilds: "*Please fill in all required fields*",
      }));
      // console.log(error.emptyFeilds, "test");
      // alert("*Please fill in all required fields*")

      formValid = false;
    } else {
      setError((prevError) => ({
        ...prevError,
        emptyFeilds: "",
      }));
    }

    // Duplicate checks
    const userNameExists = UserData.some((user) => user.user_name?.value === signup.user_name);
    const emailExists = UserData.some((user) => user.email_c?.value === signup.email_c);
    const phoneNumberExists = UserData.some(
      (user) => user.phone_mobile?.value === signup.phone_mobile
    );

    // Check for duplicate username
    if (userNameExists) {
      setError((prevError) => ({
        ...prevError,
        userNameMatchErr: "*Username is already taken*",
      }));
      formValid = false;
    } else {
      setError((prevError) => ({
        ...prevError,
        userNameMatchErr: "",
      }));
    }

    // Check for duplicate email
    if (emailExists) {
      setError((prevError) => ({
        ...prevError,
        emailDuplicateErr: "*Email is already taken*",
      }));
      formValid = false;
    } else {
      setError((prevError) => ({
        ...prevError,
        emailDuplicateErr: "",
      }));
    }

    // Check for duplicate phone number
    if (phoneNumberExists) {
      setError((prevError) => ({
        ...prevError,
        phoneNumberDuplicateErr: "*Mobile number is already taken*",
      }));
      formValid = false;
    } else {
      setError((prevError) => ({
        ...prevError,
        phoneNumberDuplicateErr: "",
      }));
    }

    // If the user selected 'Yes' for existing family member, ensure Family Group ID and Select Your Name are provided
    if (existingFamilyMember === "yes") {
      if (!familyGroupId) {
        setError((prevError) => ({
          ...prevError,
          familyGroupIdErr: "*Please enter Family Group ID*",
        }));
        formValid = false;
      } else {
        setError((prevError) => ({ ...prevError, familyGroupIdErr: "" }));
      }

      if (!selectedFamilyMember) {
        setError((prevError) => ({
          ...prevError,
          selectNameErr: "*Please select your name from family members*",
        }));
        formValid = false;
      } else {
        setError((prevError) => ({ ...prevError, selectNameErr: "" }));
      }
    }

    // If the form is invalid, stop the submission process
    if (!formValid) {
      console.log("Form is invalid. Preventing submission.");
      return; // Prevent form submission
    }

    // Check for existing family member only when user did not explicitly say 'no'
    if (existingFamilyMember !== "no") {
      const matched = findMatchingFamilyMember();
      if (matched) {
        setMatchedMember(matched);
        setIsIdentityDialogOpen(true);
        return; // Stop submission, wait for user confirmation
      }
    }

    // If form is valid and no match (or user confirmed 'no'), proceed with API call
    const proceedWithRegistration = async () => {
      setLoading(true); // Show spinner/loading state

      const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/index.php?entryPoint=CreateUser";

      let payload = {
        fields: [
          { name: "user_name", value: signup.user_name },
          { name: "user_hash", value: signup.user_hash },
          { name: "cnfrm_c", value: signup.cnfrm_c },
          { name: "first_name", value: signup.first_name },
          { name: "last_name", value: signup.last_name },
          { name: "email_c", value: signup.email_c },
          { name: "phone_mobile", value: signup.phone_mobile },
          { name: "referrer_c", value: signup.referrerName ? signup.referrerName : "" },
          { name: "gender_c", value: signup.gender },
          { name: "alivestatus_c", value: "Alive" },
        ],
      };

      // Add fields for existing family member
      if (existingFamilyMember === "yes") {
        payload.fields.push({ name: "familymemberid_c", value: selectedFamilyMember });
        payload.fields.push({ name: "familymember_c", value: true });
        payload.fields.push({ name: "family_group_id_c", value: familyGroupId });
      } else {
        payload.fields.push({ name: "familymember_c", value: false });
      }

      console.log("Registration payload:", payload);

      try {
        const response = await axios.post(apiUrl, payload);

        if (response.status === 200 && response.data.id) {
          console.log("Registration successful:", response.data);
          const newUserId = response.data.id;
          setUserId(newUserId);

          Swal.fire({
            title: "Good job!",
            text: "Registration Successfully Completed",
            icon: "success",
          });

          if (referData.isRelated && newUserId) {
            console.log("Referrer is a relation:", referData.relationship);
            await addFamilyMember(newUserId);
          }

          navigate("/authentication/sign-in"); // Redirect to sign-in page on success
        } else {
          console.error("Registration failed:", response.data);
        }
      } catch (error) {
        console.error("Error during registration:", error);
      } finally {
        setLoading(false); // Stop spinner/loading state
      }
    };

    proceedWithRegistration();
  };

  const addFamilyMember = async (newUserId) => {
    const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/customapi/AddFamilyMember.php";

    const payload = {
      name: referData.referrerName,
      relationship: referData.relationship,
      users_id_c: newUserId,
    };

    console.log("Family member payload:", payload);

    try {
      const response = await axios.post(apiUrl, payload);
      console.log("Family member API Response:", response.data);

      const recordId = response.data.id || response.data.record_id;

      if (recordId) {
        console.log("Family member added successfully. ID:", recordId);
      } else {
        console.warn("Family member addition failed:", response.data.error || response.data);
      }
    } catch (error) {
      if (error.response) {
        console.error("API error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Request setup error:", error.message);
      }
    }
  };

  const findMatchingFamilyMember = () => {
    const fullName = `${signup.first_name} ${signup.last_name}`.trim().toLowerCase();
    const userName = signup.user_name.trim().toLowerCase();
    const phone = signup.phone_mobile.trim().replace(/^\+91|^91/, ""); // Normalize phone by removing prefixes
    console.log("Matching against:", { userName, fullName, phone });
    const match = familyMembers.find(member => {
      const memberName = (member.name || "").trim().toLowerCase();
      const memberMobile = (member.mobile || "").trim().replace(/^\+91|^91/, ""); // Normalize member phone
      console.log("Checking member:", { memberName, memberMobile });
      return memberName === userName || memberName === fullName || memberMobile === phone;
    });
    console.log("Matched member:", match);
    return match;
  };

  const getFatherName = (member) => {
    if (!member.parentid_c) return "N/A";
    const parent = familyMembers.find(m => m.id === member.parentid_c && m.gender_c === "male");
    return parent ? parent.name : "N/A";
  };

  const getAddress = (member) => {
    return `${member.address || ""}, ${member.city || ""}, ${member.state || ""}, ${member.pincode || ""}, ${member.country || ""}`.replace(/^, |, $/, "").trim() || "N/A";
  };

  const handleIdentityConfirm = (isYou) => {
    setIsIdentityDialogOpen(false);
    if (isYou) {
      setConfirmMessage("This person is you");
      setIsExistingMember(true);
    } else {
      setConfirmMessage("This person is not you");
      setIsExistingMember(false);
    }
    setIsConfirmDialogOpen(true);
  };

  const handleConfirmDialogClose = () => {
    setIsConfirmDialogOpen(false);
    if (isExistingMember) {
      console.log("Existing family member details:", matchedMember);
      // Perhaps do something, like link or skip registration
    } else {
      proceedWithRegistration();
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-cover bg-center">
      <CoverLayout image={bgImage}>
        <Card
          sx={{
            width: "500px",
            maxWidth: { xs: "100%", sm: "100%", md: "600px", lg: "700px" }, // Adjusts width for medium screens
            // margin: "auto", // Centers the card on the page
            // padding: "24px" // Adds padding inside the card for better spacing
          }}
        >
          <MDBox>
            <MDTypography
              variant="h4"
              fontWeight="medium"
              color="white"
              mt={1}
              sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
                <img src={logoImage} alt="Moona" style={{ width: 85, height: 75, objectFit: 'contain' }} />
                <img src={banyanImage} alt="Banyan" style={{ width: 85, height: 75, objectFit: 'contain' }} />
              </div>
            </MDTypography>
          </MDBox>
          <form onSubmit={handleLogin}>
            <MDBox pt={4} pb={3} px={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <MDInput
                    type="text"
                    label="Existing Family Member"
                    select
                    onChange={(e) => {
                      handleChange({ target: { name: 'existingFamilyMember', value: e.target.value } });
                      const val = e.target.value;
                      setExistingFamilyMember(val);
                      if (val === 'no') {
                        setFamilyGroupId('');
                        setFamilyGraphMembers([]);
                        setSelectedFamilyMember('');
                        setError(prev => ({ ...prev, familyGroupIdErr: '', selectNameErr: '' }));
                      }
                    }}
                    value={existingFamilyMember || ''}
                    name="existingFamilyMember"
                    id="existingFamilyMember"
                    SelectProps={{ native: true }}
                    fullWidth
                  >
                    <option aria-label="None" value="" />
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </MDInput>
                  <p className="text-red-700 text-[12px]">{error.existingFamilyMemberErr}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  {/* Family Group ID OR Username depending on existingFamilyMember */}
                  {existingFamilyMember === 'yes' ? (
                    <div>
                      <MDInput
                        type="text"
                        label="Family Group ID"
                        value={familyGroupId}
                        onChange={(e) => { setFamilyGroupId(e.target.value); setError(prev => ({ ...prev, familyGroupIdErr: '' })); }}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleFetchFamilyGraph(); } }}
                        fullWidth
                        sx={{ width: '100%' }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton type="button" onClick={() => { console.log('Search Icon clicked'); handleFetchFamilyGraph(); }} edge="end" disableRipple size="small">
                                <Search fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <p className="text-red-700 text-[12px]">{error.familyGroupIdErr}</p>

                      {/* moved to full-width Grid item below to span two columns */}
                    </div>
                  ) : (
                    <MDInput
                      type="text"
                      label="Username"
                      onChange={handleChange}
                      value={signup.user_name}
                      name="user_name"
                      id="user_name"
                      fullWidth
                      autoComplete="username"
                    />
                  )}
                  {existingFamilyMember === 'no' && (
                    <>
                      <p className="text-red-700 text-[12px]">{error.userNameError}</p>
                      <p className="text-red-700 text-[12px]">{error.userNameMatchErr}</p>
                    </>
                  )}
                </Grid>

                {existingFamilyMember === 'yes' && familyGraphMembers.length > 0 && (
                  <>
                  <Grid item xs={12} sm={12} style={{ marginTop: 8 }}>
                    <Autocomplete
                      options={familyGraphMembers}
                      getOptionLabel={(option) => option?.name || ""}
                      isOptionEqualToValue={(option, value) => (option?.id || "") === (value?.id || "")}
                      value={familyGraphMembers.find((o) => o.id === selectedFamilyMember) || null}
                      onChange={(event, newValue) => {
                        // Intercept selection and prompt confirmation
                        if (newValue) {
                          setPendingSelectedMember(newValue);
                          setInputValue(newValue.name || "");
                          setError(prev => ({ ...prev, selectNameErr: '' }));
                          const relationType = (newValue.relationshipType || newValue.relationship || "").toLowerCase();
                          const orig = newValue.original || {};
                          const genderVal = (orig.gender_c || orig.gender || "").toLowerCase();
                          let relLabel = "relative";
                          if (relationType.includes("parent")) {
                            relLabel = genderVal.includes("male") ? "father" : "mother";
                          } else if (relationType.includes("spouse")) {
                            relLabel = genderVal.includes("male") ? "husband" : "wife";
                          } else if (relationType.includes("child")) {
                            relLabel = genderVal.includes("male") ? "son" : "daughter";
                          } else if (relationType.includes("myself") || relationType.includes("self")) {
                            relLabel = "you";
                          }
                          // If the selected member has a parent record, include it in the confirmation message
                          const parentRaw = (orig.parentid_c || orig.parentid || orig.parentId || "") + "";
                          const parentIds = parentRaw ? parentRaw.split(",").map(x => x.trim()).filter(Boolean) : [];
                          const parentIdToUse = parentIds[0] || "";
                          const parentEntry = parentIdToUse ? familyGraphMembers.find(fm => (fm.id === parentIdToUse || fm.original?.id === parentIdToUse || fm.original?.user_id === parentIdToUse)) : null;
                          const parentName = parentEntry ? (parentEntry.original?.name || parentEntry.name || "") : "";
                          const spouseIdRaw = (orig.spouseid_c || orig.spouseid || orig.spouseId || "") + "";
                          const spouseIdToUse = spouseIdRaw ? spouseIdRaw.split(",").map(x => x.trim()).filter(Boolean)[0] : "";
                          const spouseEntry = spouseIdToUse ? familyGraphMembers.find(fm => (fm.id === spouseIdToUse || fm.original?.id === spouseIdToUse || fm.original?.user_id === spouseIdToUse)) : null;
                          const spouseName = spouseEntry ? (spouseEntry.original?.name || spouseEntry.name || "") : "";
                          const origId = (orig.id || orig.user_id || orig.userId || orig.users_id_c || "") + "";
                          const childrenList = familyGraphMembers.filter(fm => {
                            const fmOrig = fm.original || {};
                            const pids = (fmOrig.parentid_c || fmOrig.parentid || fmOrig.parentId || "") + "";
                            const pidArr = pids.split(",").map(x => x.trim()).filter(Boolean);
                            return pidArr.includes(origId);
                          });
                          const childEntry = (childrenList && childrenList.length > 0) ? childrenList[0] : null;
                          const childName = childEntry ? (childEntry.original?.name || childEntry.name || "") : "";
                          const plainName = orig.name || (newValue.name || "").split(" S/o")[0].split(" (S/o")[0].trim();
                          let confirmationMsg = `Is ${plainName} your ${relLabel}?`;
                          if (relLabel === 'father' || relLabel === 'mother') {
                            if (parentName) confirmationMsg = `Your name is ${plainName} and your ${relLabel} is ${parentName}`;
                          } else if (relLabel === 'husband' || relLabel === 'wife') {
                            if (spouseName) confirmationMsg = `Your name is ${plainName} and your ${relLabel} is ${spouseName}`;
                          } else if (relLabel === 'son' || relLabel === 'daughter') {
                            if (childName) confirmationMsg = `Your name is ${plainName} and your ${relLabel} is ${childName}`;
                          } else if (relLabel === 'you') {
                            confirmationMsg = `Your name is ${plainName}`;
                          }
                          setSelectionConfirmMessage(confirmationMsg);
                          setSelectionConfirmOpen(true);
                        } else {
                          setPendingSelectedMember(null);
                          setInputValue("");
                          setError(prev => ({ ...prev, selectNameErr: '' }));
                          setSelectionConfirmOpen(false);
                        }
                      }}
                      inputValue={inputValue}
                      onInputChange={(event, newInputValue) => { setInputValue(newInputValue); setError(prev => ({ ...prev, selectNameErr: '' })); }}
                      renderInput={(params) => (
                        <MDInput
                          {...params}
                          label="Select Your Name"
                          fullWidth
                        />
                      )}
                      freeSolo={false}
                    />
                    <p className="text-red-700 text-[12px]">{error.selectNameErr}</p>
                  </Grid>

                  {/* Put Username below Select Your Name */}
                  <Grid item xs={12} sm={6}>
                    <MDInput
                      type="text"
                      label="Username"
                      onChange={handleChange}
                      value={signup.user_name}
                      name="user_name"
                      id="user_name"
                      fullWidth
                      autoComplete="username"
                    />
                    <p className="text-red-700 text-[12px]">{error.userNameError}</p>
                    <p className="text-red-700 text-[12px]">{error.userNameMatchErr}</p>
                  </Grid>
                  </>
                )}

                <Grid item xs={12} sm={6}>
                  <MDInput
                    type="text"
                    label="First Name"
                    onChange={handleChange}
                    value={signup.first_name}
                    name="first_name"
                    id="first_name"
                    // variant="standard"
                    fullWidth
                    autoComplete="given-name"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MDInput
                    type="text"
                    label="Last Name"
                    onChange={handleChange}
                    value={signup.last_name}
                    name="last_name"
                    id="last_name"
                    // variant="standard"
                    fullWidth
                    autoComplete="family-name"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MDInput
                    type="email"
                    label="Email"
                    onChange={handleChange}
                    value={signup.email_c}
                    name="email_c"
                    id="email_c"
                    // variant="standard"
                    fullWidth
                    autoComplete="email"
                  />


                  <p className="text-red-700 text-[12px]">{error.emailError}</p>
                  <p className="text-red-700 text-[12px]">{error.emailDuplicateErr}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MDInput
                    type="number"
                    label="Mobile No:"
                    onChange={handleChange}
                    value={signup.phone_mobile}
                    name="phone_mobile"
                    id="phone_mobile"
                    // variant="standard"
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                    fullWidth
                    sx={{
                      // Remove arrows in Chrome, Safari, Edge, and Opera
                      "& input[type=number]": {
                        "-moz-appearance": "textfield",
                      },
                      "& input[type=number]::-webkit-outer-spin-button": {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                      "& input[type=number]::-webkit-inner-spin-button": {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                    }}
                    autoComplete="tel"
                  />
                  <p className="text-red-700 text-[12px]">{error.phoneError}</p>
                  <p className="text-red-700 text-[12px]">{error.phoneNumberDuplicateErr}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MDInput
                    type="text"
                    label="Gender"
                    select
                    onChange={(e) => {
                      handleChange(e);
                      setSignup((prev) => ({ ...prev, gender: e.target.value }));
                    }}
                    value={signup.gender}
                    name="gender"
                    id="gender"
                    SelectProps={{ native: true }}
                    fullWidth
                  >
                    <option aria-label="None" value="" />
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </MDInput>
                  <p className="text-red-700 text-[12px]">{error.genderErr}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MDInput
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    onChange={handleChange}
                    value={signup.user_hash}
                    name="user_hash"
                    id="user_hash"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            disableRipple
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": { backgroundColor: "transparent" },
                              padding: "0 0 10 0",
                            }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "transparent",
                      },
                    }}
                    autoComplete="new-password"
                  />
                  <p className="text-red-700 text-[12px]">{error.valiatation}</p>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MDInput
                    type={showConfirmPassword ? "text" : "password"}
                    label="Confirm Password"
                    onChange={handleChange}
                    value={signup.cnfrm_c}
                    name="cnfrm_c"
                    id="cnfrm_c"
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            edge="end"
                            disableRipple
                            sx={{
                              backgroundColor: "transparent",
                              "&:hover": { backgroundColor: "transparent" },
                              padding: "0 0 10 0",
                            }}
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "transparent",
                      },
                    }}
                    autoComplete="new-password"
                  />
                  <p className="text-red-700 text-[12px]">{error.matchError}</p>
                </Grid>
              </Grid>

              <MDBox display="flex" alignItems="center" ml={-1} mt={2}>
                <Checkbox checked />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1, color: "#012034" }}
                >
                  &nbsp;&nbsp;I agree to the&nbsp;
                  <MDTypography
                    component="a"
                    href="#"
                    variant="button"
                    fontWeight="bold"
                    sx={{ color: "#012034" }}
                    textGradient
                  >
                    Terms and Conditions
                  </MDTypography>
                </MDTypography>
              </MDBox>

              <MDBox mt={4} mb={1} textAlign="center">
                {loading ? (
                  <div className="flex justify-center">
                    <ColorRing
                      visible={true}
                      height="80"
                      width="80"
                      ariaLabel="color-ring-loading"
                      wrapperStyle={{}}
                      wrapperClass="color-ring-wrapper"
                      colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
                    />
                  </div>
                ) : (
                  <Button
                    type="submit"
                    variant="gradient"
                    sx={{
                      backgroundColor: "#012034",
                      color: "#ffffff",
                      width: "40%",
                      padding: "6px 8px",
                      fontSize: "1rem",
                      "&:hover": { backgroundColor: "#012034" },
                      "&:active": { backgroundColor: "#012034" },
                    }}
                  >
                    Register
                  </Button>
                )}
              </MDBox>

              <MDBox mt={3} mb={1} textAlign="center">
                <MDTypography variant="button" sx={{ color: "#012034" }}>
                  Already have an account?{" "}
                  <MDTypography
                    component={Link}
                    to="/authentication/sign-in"
                    variant="button"
                    sx={{ color: "#012034" }}
                    fontWeight="medium"
                    textGradient
                  >
                    Sign In
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </form>
        </Card>
      </CoverLayout>

      {/* Identity Check Dialog */}
      <Dialog open={isIdentityDialogOpen} onClose={() => setIsIdentityDialogOpen(false)}>
        <DialogTitle>Is this you?</DialogTitle>
        <DialogContent>
          <MDTypography variant="body1" mb={2}>
            We found a family member with similar details:
          </MDTypography>
          <MDTypography variant="body2">
            <strong>Name:</strong> {matchedMember?.name}
          </MDTypography>
          <MDTypography variant="body2">
            <strong>Father's Name:</strong> {matchedMember ? getFatherName(matchedMember) : ""}
          </MDTypography>
          <MDTypography variant="body2">
            <strong>Address:</strong> {matchedMember ? getAddress(matchedMember) : ""}
          </MDTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleIdentityConfirm(false)}>No</Button>
          <Button onClick={() => handleIdentityConfirm(true)}>Yes</Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog open={isConfirmDialogOpen} onClose={handleConfirmDialogClose}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <MDTypography variant="body1">{confirmMessage}</MDTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* Selection Confirmation Dialog */}
      <Dialog open={selectionConfirmOpen} onClose={() => { setPendingSelectedMember(null); setSelectionConfirmOpen(false); }}>
        <DialogTitle>Confirm Selection</DialogTitle>
        <DialogContent>
          <MDTypography variant="body1">{selectionConfirmMessage}</MDTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            // Cancel selection
            setPendingSelectedMember(null);
            setInputValue(selectedFamilyMember ? (familyGraphMembers.find(o => o.id === selectedFamilyMember)?.name || "") : "");
            setError(prev => ({ ...prev, selectNameErr: '' }));
            setSelectionConfirmOpen(false);
          }}>No</Button>
                      <Button onClick={() => {
            // Confirm selection: set selectedFamilyMember and populate fields
            const newValue = pendingSelectedMember;
            if (newValue) {
              setSelectedFamilyMember(newValue.id);
                        const displayName = newValue?.name || "";
              const firstToken = (displayName.split(" ")[0] || displayName);
                        const explicitUsername = newValue?.user_name || newValue?.userName || newValue?.username || newValue?.original?.user_name || newValue?.original?.userName || newValue?.original?.username || "";
              let usernameToSet = explicitUsername ? explicitUsername : (displayName.includes(" ") ? firstToken.toLowerCase() : sanitizeUsername(displayName));
              setSignup((prev) => ({
                ...prev,
                user_name: usernameToSet,
                first_name: firstToken,
              }));
              setInputValue(displayName);
              setError(prev => ({ ...prev, selectNameErr: '' }));
            }
            setPendingSelectedMember(null);
            setSelectionConfirmOpen(false);
          }}>Yes</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SignUp;
